import { render } from "./JobDashboard.vue?vue&type=template&id=517e1b70&scoped=true"
import script from "./JobDashboard.vue?vue&type=script&lang=js"
export * from "./JobDashboard.vue?vue&type=script&lang=js"

import "./JobDashboard.vue?vue&type=style&index=0&id=517e1b70&scoped=true&lang=scss"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/deguild-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-517e1b70"]])

export default __exports__